import gsap from "gsap";

const toggle = document.querySelector(".menu-toggle");
const toggleSpan = document.querySelectorAll(".menu-toggle span");
const menu = document.querySelector(".menu");
const navItem = menu.querySelectorAll(".menu-nav__item");
const navLink = menu.querySelectorAll(".menu-nav__link");
const menuLogo = menu.querySelector(".menu-logo");
const body = document.body;

const tlMenu = gsap.timeline({
	paused: true,
	reversed: true,
	defaults: {
		ease: "power3.out",
	},
});

gsap.set(menu, { left: "120%" });

tlMenu
	.to(menu, { left: 0 })
	.to(toggle, { rotation: 360, backgroundColor: "var(--toggle-btn-current)" }, 0)
	.to(toggleSpan, { backgroundColor: "var(--toggle-icon-current)" }, 0)
	.to(toggleSpan[0], { rotate: 45, y: "-50%", x: "0" }, 0)
	.to(toggleSpan[1], { opacity: 0 }, 0)
	.to(toggleSpan[2], { rotate: -45, y: "-50%", x: "0" }, 0)
	.to(menuLogo, { opacity: 1 }, 0)
	.to(
		navItem,
		{
			opacity: 1,
			left: 0,
			stagger: {
				each: 0.02,
			},
		},
		">-0.5"
	);

// Funktion, um `aria-hidden`-Attribut und `tabindex` zu verwalten
const setMenuAccessibility = (isOpen) => {
	menu.setAttribute("aria-hidden", isOpen ? "false" : "true");

	// `tabindex` der Links steuern
	navLink.forEach(link => {
		link.setAttribute("tabindex", isOpen ? "0" : "-1");
	});
};

// Funktion zum Öffnen des Menüs
const menuToggleOpen = () => {
	setTimeout(() => {
		toggle.setAttribute("aria-expanded", "true");
		setMenuAccessibility(true);  // Menü als zugänglich markieren
		tlMenu.play();
		// body.style.overflowY = "hidden";
	}, 1);
};

// Funktion zum Schließen des Menüs mit Timeout für `aria-hidden`
export const menuToggleClose = () => {
	setTimeout(() => {
		toggle.setAttribute("aria-expanded", "false");
		tlMenu.reverse();
		// body.style.overflowY = "initial";

		// Timeout, um `aria-hidden="true"` nach Ende der Schließanimation zu setzen
		setTimeout(() => {
			setMenuAccessibility(false); // Menü als nicht zugänglich markieren
		}, 1500); // Anpassen auf die Dauer der Schließanimation in Millisekunden
	}, 1);
};

// Sofortige Schließung ohne Animation
export const menuToggleInstant = () => {
	toggle.setAttribute("aria-expanded", "false");
	setMenuAccessibility(false); // Menü als nicht zugänglich markieren
	tlMenu.restart();
	tlMenu.pause();
};

// Toggle-Eventlistener für den Button
export const menuToggle = () => {
	toggle.addEventListener("click", () => {
		if (toggle.getAttribute("aria-expanded") === "false") {
			menuToggleOpen();
		} else {
			menuToggleClose();
		}
	});
};

// Setzt den aktiven Zustand der Navigationslinks basierend auf der URL
export const navState = () => {
	navLink.forEach((link) => {
		link.removeAttribute("aria-current", "page");

		if (link.href.split("/").pop().split("#").shift() === window.location.href.split("/").pop().split("#").shift()) {
			link.setAttribute("aria-current", "page");
		}

		if (window.location.href.split("/").pop() === "") {
			document.querySelectorAll(".menu-nav__link")[0].setAttribute("aria-current", "page");
		}
	});
};

// Scroll-Funktion für Menüanker
window.anchorScroll = function (x) {
	menuToggleClose();

	setTimeout(function () {
		gsap.to(window, {
			duration: 1,
			scrollTo: {
				y: "#" + x,
			},
		});
	}, 1000);
};
